import { ContentContainer } from './styled.js';
import { jsx } from 'react/jsx-runtime';
import { useTabManager } from '../hooks/useTabManager/useTabManager.js';

function TabContent(props) {
  var children = props.children,
    tabId = props.tabId,
    className = props.className;
  var _useTabManager = useTabManager(),
    activeTab = _useTabManager.activeTab,
    tabGroupId = _useTabManager.tabGroupId;
  if (tabId !== activeTab) {
    return null;
  }
  return /*#__PURE__*/jsx(ContentContainer, {
    tabIndex: activeTab === tabId ? 0 : -1,
    role: "tabpanel",
    "aria-labelledby": tabId + "-" + tabGroupId,
    className: className,
    children: children
  });
}

export { TabContent };
